// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2J-43","title":"ClientInsurance_title__3Vwbr","itemText":"ClientInsurance_itemText__3W6hK"};